import {Box, CircularProgress, Grid} from '@material-ui/core';
import {StartBtn} from 'components/Learners/Directions/styles';
import {useForm} from 'hooks/useForm';
import React from 'react';
import {postTestingAnswers} from 'services/auth';
import Quest from '../Quest';

const Cashier = ({direction, hideTeory, showCongratulations}) => {
  const {form, setFormItem} = useForm({
    '1': null,
    '2': null,
    '3': null,
    '4': null,
    '5': null,
  });

  const [answerLoading, setAnswerLoading] = React.useState(false);
  const [isAnswer, setIsAnswer] = React.useState(false);

  const data = [form['1'], form['2'], form['3'], form['4'], form['5']];

  const handleAnswerPost = () => {
    setAnswerLoading(true);

    postTestingAnswers(direction, data).then((res) => {
      setAnswerLoading(false);
      setIsAnswer(true);
      showCongratulations()
    });
  };

  return (
    <Grid container style={{zIndex: 2}}>
      <Grid item xs={6}>
        <Quest
          title={'1. Какие обязанности у кассира?'}
          answers={[
            'Объяснение правил игры клиентам казино',
            'Покупка и продажа фишек казино у клиентов',
            'Обслуживание клиентов в зале',
          ]}
          value={form['1']}
          setAnswers={(id) => setFormItem('1', id)}
          correct={isAnswer ? 1 : null}
        />
      </Grid>
      <Grid item xs={6}>
        <Quest
          title={'2. За что несет ответственность кассир?'}
          answers={[
            'За наличные деньги, фишки и номиналы',
            'За размер выигрыша клиента',
            'За совокупность баланса банка к концу рабочей смены',
          ]}
          value={form['2']}
          setAnswers={(id) => setFormItem('2', id)}
          correct={isAnswer ? 0 : null}
        />
      </Grid>
      <Grid item xs={6}>
        <Quest
          title={'3. Какого номинала нет среди рабочих инструментов кассира?'}
          answers={['Фишки (чипы)', 'Наличные деньги', 'Подарочный сертификат']}
          value={form['3']}
          setAnswers={(id) => setFormItem('3', id)}
          correct={isAnswer ? 2 : null}
        />
      </Grid>
      <Grid item xs={6}>
        <Quest
          title={'4. Что обеспечивает касса кассира?'}
          answers={[
            'Фонды заведения, для проведения сделок',
            'Сохранность вкладов клиентов',
            'Обеспечивает фиксированную процентную ставку',
          ]}
          value={form['4']}
          setAnswers={(id) => setFormItem('4', id)}
          correct={isAnswer ? 0 : null}
        />
      </Grid>
      <Grid item xs={6}>
        <Quest
          title={'5. Что содержит касса?'}
          answers={[
            'Накапливающий банк (Collect)',
            'Заполняющий банк (Fill)',
            'Семью и родственников кассира',
          ]}
          value={form['5']}
          setAnswers={(id) => setFormItem('5', id)}
          correct={isAnswer ? 1 : null}
        />
      </Grid>
      <Grid item xs={6}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{width: '100%', height: '100%'}}
        >
          <StartBtn
            disabled={!!data.filter((a) => a === null).length}
            onClick={isAnswer ? hideTeory : handleAnswerPost}
          >
            {isAnswer ? (
              'Перейти к практике'
            ) : answerLoading ? (
              <CircularProgress />
            ) : (
              'ОТПРАВИТЬ'
            )}
          </StartBtn>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Cashier;
